import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Row, Typography, Radio, message } from 'antd'
import { Context, useStore } from '../context'
import PosSrc from '../pages/pos/PosSrc'

const { Title } = Typography

function HeaderPage(props) {
  const [switched, setSwitched] = useState(false)

  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const handlerShowDrawer = () => {
    props.showDrawer()
  }

  useEffect(() => {
    if (props.store?.store_correlative) {
      setSwitched(props.store?.store_correlative.switched)
    }
  }, [props.store])

  const changeSwitch = value => {
    if (!props.store?.store_correlative?.id) {
      return message.error('La tienda no tiene correlativo interno asignado.')
    }

    PosSrc.updateSwitchStore(props.store?.store_correlative?.id, { switch: value, store_id: props.store?.id })
      .then(res => {
        if (res?.id) {
          setSwitched(value)
        } else {
          message.error(res.errors.message);
        }
      })
      .catch(e => {
        message.error(e)
      })
  }

  return (
    <Row type="flex" justify="center" align="top" className="margin-top-40">
      {!props.pos ? (
        <>
          <Col xs={24} sm={24} md={12} lg={20}>
            <Title>{props.title}</Title>
          </Col>
          <Col xs={24} sm={24} md={12} lg={{ span: 4, offset: 0 }} className="text-right">
            {hasPermissions([props.permissions]) && (props.create !== undefined ? (props.create === 1 ? true : false) : true) && props.title && (
              <Button className="title-tendero new-button" onClick={handlerShowDrawer}>
                {props.titleButton}
              </Button>
            )}
          </Col>
        </>
      ) : (
        <>
          <Col xs={6} sm={6} md={6} lg={6}>
            <Title>{props.title}</Title>
          </Col>
          {props.open && (
            <>
              <Col xs={3} sm={3} md={3} lg={3} className="text-right">
                <span className={'label-bold-500 ratio-button-labels'}>¿FEL?</span>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} className="text-center">
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={switched}
                  onChange={value => changeSwitch(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </>
          )}
          <Col xs={24} sm={12} md={6} lg={6} className="text-right">
            {props.open && (
              <Row className={'pos-store-information'}>
                <Col span={24}>
                  <span className="store-name">{props.store.name}</span>
                  <span className="store-spacer">|</span> {`${props.turnInfo.start_time.slice(0, 5)} - ${props.turnInfo.end_time.slice(0, 5)}`}
                </Col>
              </Row>
            )}
          </Col>
          <Col xs={24} sm={12} md={4} lg={4} className="text-right">
            {hasPermissions([45]) && (
              <Button className="title-tendero new-button" onClick={handlerShowDrawer}>
                {!props.open ? 'Iniciar turno' : 'Cerrar turno'}
              </Button>
            )}
          </Col>
        </>
      )}
    </Row>
  )
}

export default HeaderPage
